import React, { useState } from 'react';
import './DemandModal.css';
import { BuyerApi } from '../../apis/BuyerApi';
import ShowHint from '../ShowHint/ShowHint';

interface DemandModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DemandModal: React.FC<DemandModalProps> = ({ isOpen, onClose }) => {
  const [demand, setDemand] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [hintMessage, setHintMessage] = useState('');
  const [hintType, setHintType] = useState<'success' | 'error' | 'warning' | 'info'>('error');

  const handleSubmit = () => {
    if (demand.trim().length < 10) {
      setHintMessage('请至少输入10个字符描述您的需求');
      setHintType('error');
      setShowHint(true);
      return;
    }
    setShowConfirm(true);
  };

  const handleConfirmSubmit = async () => {
    setIsSubmitting(true);
    try {
      const success = await BuyerApi.postSoftwareDevDemand(demand.trim());
      if (success) {
        setHintMessage('提交成功！我们的工作人员会尽快联系您。');
        setHintType('success');
        setShowHint(true);
        setDemand('');
        setShowConfirm(false);
        // 延迟关闭弹框，让用户看到成功提示
        setTimeout(() => {
          onClose();
        }, 3000);
      } else {
        setHintMessage('提交失败，请稍后重试');
        setHintType('error');
        setShowHint(true);
        setShowConfirm(false);
      }
    } catch (error) {
      setHintMessage('提交失败，请稍后重试');
      setHintType('error');
      setShowHint(true);
      setShowConfirm(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  const handleClose = () => {
    setDemand('');
    setShowConfirm(false);
    setShowHint(false);
    onClose();
  };

  const handleHintClose = () => {
    setShowHint(false);
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="demand-modal-overlay" onClick={handleClose}>
        <div className="demand-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="demand-modal-header">
            <h2>登记您的软件开发需求</h2>
            <button className="demand-modal-close" onClick={handleClose}>×</button>
          </div>
          
          <div className="demand-modal-body">
            <div className="demand-input-container">
              <textarea
                className="demand-textarea"
                placeholder="请简短描述下您的软件开发需求"
                value={demand}
                onChange={(e) => setDemand(e.target.value)}
                rows={6}
                maxLength={500}
              />
              <div className="demand-input-footer">
                <div className="demand-char-count">
                  {demand.length}/500
                </div>
                <div className="demand-tip">
                  您登记后，我们的工作人员会尽快联系您。
                </div>
              </div>
            </div>
          </div>
          
          <div className="demand-modal-footer">
            <button 
              className="demand-btn demand-btn-secondary" 
              onClick={handleClose}
            >
              取消
            </button>
            <button 
              className="demand-btn demand-btn-primary" 
              onClick={handleSubmit}
            >
              提交需求
            </button>
          </div>
        </div>
      </div>

      {/* 确认弹框 */}
      {showConfirm && (
        <div className="demand-confirm-overlay">
          <div className="demand-confirm-content">
            <div className="demand-confirm-header">
              <h3>确认提交</h3>
            </div>
            <div className="demand-confirm-body">
              <p>您确认已经描述好您的开发需求了吗？提交后我们的工作人员会尽快联系您。</p>
            </div>
            <div className="demand-confirm-footer">
              <button 
                className="demand-btn demand-btn-secondary" 
                onClick={handleCancel}
                disabled={isSubmitting}
              >
                我再想想
              </button>
              <button 
                className="demand-btn demand-btn-primary" 
                onClick={handleConfirmSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? '提交中...' : '确认提交'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      <ShowHint 
        visible={showHint}
        message={hintMessage}
        type={hintType}
        duration={3000}
        onClose={handleHintClose}
      />
    </>
  );
};

export default DemandModal; 